import './Backdrop.css';

/* ============================================================================
   Backdrop — the living background behind every screen.

   Slow counter-rotating red plumes over deep blue, plus a synthwave horizon
   grid. Pure CSS transforms on four elements, so it costs a compositor layer
   and nothing else — no canvas, no rAF loop competing with the game.
   ========================================================================== */

function Backdrop() {
  return (
    <div className="ui-backdrop" aria-hidden="true">
      <div className="ui-backdrop__wash" />
      <div className="ui-backdrop__plume ui-backdrop__plume--a" />
      <div className="ui-backdrop__plume ui-backdrop__plume--b" />
      <div className="ui-backdrop__grid" />
      <div className="ui-backdrop__horizon" />
    </div>
  );
}

export default Backdrop;
